import React from "react";

// Lazy loading components for improved performance
// React.lazy is used to dynamically import components when they are needed
export const UserNutritionList = React.lazy(() => import("./UserNutritionList/index.page"));
export const UserNutritionDetails = React.lazy(() => import("./UserNutritionDetails/index.page"));

